
import { defineComponent, PropType, ref } from "vue";
import ActionsCell from "./ActionsCell.vue";

export default defineComponent({
  name: "TableRows",
  components: { ActionsCell },
  props: {
    routeKey: { type: String, required: true },
    mapping: { type: Object as PropType<any>, required: true },
    items: { type: Array as PropType<any[]>, required: true },
    hasActions: { type: Boolean, default: false },
    pagination: { type: Object as PropType<any>, required: false },
  },
  emits: ["open-modal", "delete", "move-up", "move-down", "row-action"],
  setup(props, { emit }) {
    const expandedId = ref<number | null>(null);

    const toggle = (id: number) => {
      expandedId.value = expandedId.value === id ? null : id;
    };

    const isExpanded = (item: any) => expandedId.value === item[props.mapping.PrimaryKey];

    const isRenderable = (col: any) =>
      ["text", "email", "computed", "money", "image", "array", "date", "object", "coloredObject", "location"].includes(col.type);

    const handleClick = (col: any, item: any) => {
      if (!col.click) return;
      col.click(item[props.mapping.PrimaryKey], props.routeKey);
    };

    const handleInnerClick = (col: any, item: any) => {
      if (!col.click) return;
      col.click(item[props.mapping.PrimaryKey], props.routeKey);
    };

    return {
      expandedId,
      toggle,
      isExpanded,
      isRenderable,
      handleClick,
      handleInnerClick,
    };
  },
});
